import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../components/common/Error/Error";
import Loading from "../../components/common/Loading/Loading";
import {fetchApp} from '../../store/apps/actions';
import style from '../../styles/styles';
import styles from './EditPageMediaPage.css';
import {fetchPage, putPageMedia, fetchPageMedia} from "../../store/pages/actions";
import {getMediaTypes} from "../../store/mediatypes/actions";
import MediaForm from "../../components/media/MediaForm/MediaForm";
import withTranslation from "../../hoc/withTranslation";

export class EditPageMediaPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        page: PropTypes.object,
        media: PropTypes.object
    };

    static defaultProps = {
        mediaTypes: []
    };

    componentWillMount() {
        this.fetch();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.pageId, nextProps.match.params.mediaId)
        }

        if (this.props.sending && !nextProps.sending) {
            this.props.history.goBack();
        }

        if (nextProps.app && this.props.mediaTypes.count === 0) {
            this.fetchMediaTypes(nextProps.app.id);
        }

        if (nextProps.app && this.props.app !== nextProps.app && this.props.page === null) {
            this.fetchPage(nextProps.app.id, nextProps.match.params.pageId);
        }

        if (nextProps.app && nextProps.entity && this.props.entity !== nextProps.entity) {
            this.fetchMedia(nextProps.app.id, nextProps.page.id, nextProps.match.params.mediaId);
        }

    }

    // Fetch

    fetch(appId = null, pageId = null, mediaId = null) {
        this.fetchApplication(appId);
        this.fetchPage(appId, pageId);
        this.fetchMedia(appId, pageId, mediaId);
        this.fetchMediaTypes(appId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchPage(appId = null, pageId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const page = pageId || this.props.match.params.pageId;

            if (app && page) {
                this.props.fetchPage(app, page, this.props.lang);
            }
        }
    }

    fetchMediaTypes(appId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;

            if (app) {
                this.props.getMediaTypes(app);
            }
        }
    }

    fetchMedia(appId = null, pageId = null, mediaId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const page = pageId || this.props.match.params.pageId;
            const media = mediaId || this.props.match.params.mediaId;

            if (app && page && media) {
                this.props.fetchPageMedia(app, page, media, this.props.lang);
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.putPageMedia(this.props.app.id, this.props.page.id, formProps, this.props.lang);
    };

    // Render

    renderForm() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">

                <Paper style={styles.editBox}>
                    <Subheader style={style.subHeader}>{this.props.media.picture}</Subheader>
                    <div style={style.paper}>
                        <MediaForm
                            onSubmit={this.handleFormSubmit}
                            initialValues={this.props.initialValues}
                            submitting={this.props.sending}
                            media={this.props.media}
                            mediaTypes={this.props.mediaTypes}
                        />
                    </div>
                    <div style={style.clear} />
                </Paper>
            </div>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.page || !this.props.media) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('medias.media')} / {this.props.t('generic.edit')} - {this.props.page.title} - {this.props.media.name} ({this.props.media.mime_type})</h3>
                    <div className="row">
                        {this.renderForm()}
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.pages.pending || state.mediaTypes.pending,
        error: state.pages.error || state.apps.error,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.pages.sending,
        mediaTypes: state.mediaTypes.content,
        page: state.pages.currentPage,
        media: state.pages.currentMedia
    };

    if (props.media) {
        props.initialValues = props.media;
    }

    return props;
}

export default connect(mapStateToProps, {
    getMediaTypes,
    putPageMedia,
    fetchApp,
    fetchPage,
    fetchPageMedia
})(withTranslation(EditPageMediaPage));



// WEBPACK FOOTER //
// src/containers/page/EditPageMediaPage.js